export default "__VITE_ASSET__BXCiYMIy__"